import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import Caption, { VARIANT as CAPTION_VARIANT } from '@/components/Caption';
import useRelatedPosts from '@/hooks/useRelatedPosts';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { DehaatPosts } from '@/models/Posts';
import styles from '@/styles/TruncateContent.module.css';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import { isArray } from '@/utils/helper';
import SubHeading, { VARIANT as SUBHEADING_VARIANT } from '../SubHeading';
import MediaCard from './MediaCard';
interface Props {
  slug: string;
  postType?: string;
}
const PostCard = ({
  attachments,
  name,
  slug,
  tags
}: DehaatPosts) => {
  const {
    t
  } = useTranslation('posts');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const handleClick = () => {
    trackCustomEvent(CustomEventTypes.DEHAAT_FEED_CLICK, isArray(tags) ? JSON.stringify(tags) : undefined);
  };
  return <Link href={`/blog/${slug}`} className="flex gap-3 md:gap-1 md:grid md:grid-cols-2 my-4 max-w-md" onClick={handleClick} data-sentry-element="Link" data-sentry-component="PostCard" data-sentry-source-file="RelatedPosts.tsx">
      <div className="flex justify-center items-center w-[116px] md:w-[200px] h-18 md:h-[200px] shrink-0">
        {/* Explicitly passing any video content as empty since we don't want video to load for related posts unnecessarily */}
        <MediaCard attachments={{
        images: attachments.images,
        attached_images: attachments.attached_images,
        video_links: [],
        videos: [],
        audios: []
      }} slug={slug} data-sentry-element="MediaCard" data-sentry-source-file="RelatedPosts.tsx" />
      </div>
      <div>
        <p className={styles.truncate_after_two_lines}>{name}</p>
        <span className="font-nato-semibold text-primary-100 text-xs">
          {t('read_more_btn')}
        </span>
      </div>
    </Link>;
};
const RelatedPosts = ({
  slug,
  postType
}: Props) => {
  const {
    t
  } = useTranslation('posts');
  const {
    error,
    loading,
    relatedPosts
  } = useRelatedPosts(slug, postType);
  if (relatedPosts.length === 0) return null;
  if (loading) return <SubHeading variant={SUBHEADING_VARIANT.SMALL} className="border-y border-y-neutral-20 border-solid">
        {t('loading_caption')}
      </SubHeading>;
  return <div className="border-t border-t-neutral-20 border-solid" data-sentry-component="RelatedPosts" data-sentry-source-file="RelatedPosts.tsx">
      <SubHeading variant={SUBHEADING_VARIANT.LARGE} data-sentry-element="SubHeading" data-sentry-source-file="RelatedPosts.tsx">
        {t('related_posts_caption')}
      </SubHeading>

      <div className="grid grid-cols-1 md:grid-cols-2 mt-3">
        {relatedPosts.map(item => <PostCard key={item.id} {...item} />)}
      </div>
      {error !== '' && <Caption variant={CAPTION_VARIANT.ONE} label={t(error)} className="text-center" />}
    </div>;
};
export default RelatedPosts;